import { TrendingUp, TrendingDown } from 'lucide-react';
import clsx from 'clsx';

const StatCard = ({ 
  title, 
  value, 
  icon: Icon, 
  trend = null, 
  color = 'blue',
  loading = false 
}) => {
  const colorClasses = {
    blue: 'bg-blue-50 border-blue-200 text-blue-600',
    green: 'bg-green-50 border-green-200 text-green-600',
    purple: 'bg-purple-50 border-purple-200 text-purple-600',
    orange: 'bg-orange-50 border-orange-200 text-orange-600',
    red: 'bg-red-50 border-red-200 text-red-600',
  };

  return (
    <div className={clsx(
      'bg-white rounded-lg border p-6 transition-shadow hover:shadow-md',
      colorClasses[color]
    )}>
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-gray-600 mb-1">{title}</p>
          {loading ? (
            <div className="h-8 bg-gray-200 rounded animate-pulse w-24" />
          ) : (
            <p className="text-3xl font-bold text-gray-900">{value}</p>
          )}
          
          {trend !== null && (
            <div className="flex items-center gap-1 mt-2">
              {trend >= 0 ? (
                <TrendingUp className="w-4 h-4 text-green-600" />
              ) : (
                <TrendingDown className="w-4 h-4 text-red-600" />
              )}
              <span className={clsx(
                'text-xs font-semibold',
                trend >= 0 ? 'text-green-600' : 'text-red-600'
              )}>
                {Math.abs(trend)}% vs mes anterior
              </span>
            </div>
          )}
        </div>

        {Icon && (
          <div className="p-3 rounded-lg bg-white bg-opacity-50">
            <Icon className="w-6 h-6" />
          </div>
        )}
      </div>
    </div>
  );
};

export default StatCard;
